<template>
  <v-card class="sign-up__card">
    <v-card-text>
      <div class="sign-up__category">
        <VIcon
          icon="mdi-map-marker-outline"
          size="large"
          class="sign-up__icon"
        />

        <h3>Виберіть місто Вашого бізнесу</h3>
        <div class="sign-up__group">
          <select v-model="selectedCityId" required ref="cityInput">
            <option value disabled selected>Обрати місто</option>
            <option
              :value="`${city.id}`"
              v-for="city in cities"
              :key="city.id"
            >
              {{ city.name }}
            </option>
          </select>
        </div>

        <p>Це допоможе точніше знайти адресу вашого бізнесу на наступному кроці.</p>
      </div>
      <div class="sign-up__btns">
        <VBtn @click="nextClick" class="sign-up__btn sign-up__btn-black">
          Продовжити
        </VBtn>
        <VBtn class="sign-up__btn" @click="backClick" variant="text">
          Назад
        </VBtn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import { getCities } from "@/main/services/api.service";
import { City } from "@/main/types/city.type";
import { onMounted, ref } from "vue";

const emit = defineEmits<{
  (e: "nextClick", value: { city: City }): void;
  (e: "backClick"): void;
}>();

const cities = ref<City[]>([]);
const selectedCityId = ref("");
const cityInput = ref<HTMLSelectElement>();

onMounted(async () => {
  try {
    cities.value = await getCities();
  } catch (error) {
    console.log(error);
  }
});

const nextClick = () => {
  if (!cityInput.value?.checkValidity()) {
    cityInput.value?.reportValidity();
    cityInput.value?.focus();
    return;
  }

  const city = cities.value.find((c) => `${c.id}` === selectedCityId.value);
  if (!city) return;

  emit("nextClick", { city });
};
const backClick = () => emit("backClick");
</script>

<style lang="scss" scoped>
.sign-up {
  &__card {
    width: 100%;
    height: 642px;
  }

  &__icon {
    color: #2e2a2a;
    font-size: 60px;
    margin-bottom: 75px;
  }

  .v-card-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }

  &__category {
    width: 100%;
    text-align: center;
    padding: 9px 90px;
    margin-bottom: 60px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 768px) {
      padding: 9px 20px;
    }

    p {
      color: #2e2a2a;
      text-align: center;
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
      padding-top: 24px;
    }

    h3 {
      font-size: 24px;
      font-weight: 600;
      color: #2e2a2a;
      max-width: 300px;
      margin-bottom: 24px;
    }

    select {
      cursor: pointer;
      border-radius: 15px;
      background: #ececec;
      padding: 15px;
      outline-color: #c4c3c3;
      color: #807575;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
    }
  }
}
</style>
